var _defs, _g, _polygon, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a5e980e2-fe6c-4b4b-bd88-a9c235de5a4d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "af3748e9-b70c-45be-94d6-553fb78dc833",
    x1: -481.386,
    y1: -747.701,
    x2: -463.782,
    y2: -778.247,
    gradientTransform: "matrix(0.5, 0.866, -0.866, 0.5, -419.682, 794.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366,
    stopColor: "#004e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bccb774a-3f0f-4cfb-8caf-da5943d5aaf7",
    x1: -1395.588,
    y1: 671.239,
    x2: -1374.204,
    y2: 633.738,
    gradientTransform: "matrix(-0.5, -0.866, 0.866, -0.5, -1249.226, -858.396)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#004685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ecd98112-5cbf-4c9b-800a-df61d86f7d77",
    x1: 6.003,
    y1: 14.447,
    x2: 7.447,
    y2: 6.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#79eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#99edff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#b0efff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#bef1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3f1ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.243,3.927l4.372,2.515,3.048-1.76A8.792,8.792,0,0,0,2.735,2.824,10.019,10.019,0,0,1,9.243,3.927Z",
    fill: "url(#af3748e9-b70c-45be-94d6-553fb78dc833)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.558,6.442l-.069,6.034,3.168.851A8.792,8.792,0,0,0,11.415.536,10.442,10.442,0,0,1,13.558,6.442Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.552,11.646,9,14.276l.071,3.5a8.8,8.8,0,0,0,8.764-8.8,8.432,8.432,0,0,0-.288-2.09A9.573,9.573,0,0,1,13.552,11.646Z",
    fill: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,14.276l-4.555-2.63-3.02,1.812a8.78,8.78,0,0,0,13.672,1.881A9.908,9.908,0,0,1,9,14.276Z",
    fill: "url(#bccb774a-3f0f-4cfb-8caf-da5943d5aaf7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.442,11.646l.069-6.237L1.394,4.588A8.744,8.744,0,0,0,.2,9a8.847,8.847,0,0,0,6.535,8.5A10.191,10.191,0,0,1,4.442,11.646Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6,6.3,9,3.757A10.579,10.579,0,0,0,3.058,2.512,8.758,8.758,0,0,0,.2,9a9.013,9.013,0,0,0,.314,2.32A10.25,10.25,0,0,1,4.6,6.3Z",
    fill: "#5ea0ef"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.552 11.646 13.552 6.386 8.997 3.757 4.442 6.386 4.442 11.646 8.997 14.276 13.552 11.646",
    fill: "#c3f1ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "9.003 9.071 9.003 14.276 4.442 11.646 4.442 6.404 9.003 9.071",
    fill: "url(#ecd98112-5cbf-4c9b-800a-df61d86f7d77)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "8.997 9.071 8.997 14.276 13.558 11.646 13.558 6.404 8.997 9.071",
    fill: "#50e6ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDev);
export default __webpack_public_path__ + "static/media/CustomDev.f25aa1b91f4f0a9a996da2dfed779a72.svg";
export { ForwardRef as ReactComponent };